import { ConfigProvider } from "antd";
import { ReactNode } from "react";

export function GreenButtonWrapper({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#10b981",
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
